<template>
    <div class="footer-wrap">
        <div class="footer-bg"></div>
        <div class="footer">
            <div class="left">
                <img class="barlogo" src="../../static/webp1/barlogo.png" alt="" />
                <div class="text-div">
                    <span class="foot-text left-text">学校地址：安徽省马鞍山市湖东北路400号</span>
                    <span class="foot-text">邮编：243002</span>
                </div>
                <div class="text-div">
                    <span class="foot-text left-text">安徽工业大学资产与实验室管理处招标采购中心</span>
                    <span class="foot-text">电子信箱： zcc@ahut.edu.cn </span>
                </div>
                <div class="text-phone">
                    <span class="phone-text">电话（传真）：</span>
                    <span class="phone-right">0555—2311291</span>
                </div>
            </div>

            <div class="right">
                <span class="foot-title" @click="jumpLink('')">学校采购代理机构</span>
                <div class="split">
                    <div class="split-left ">
                        <span class="foot-text right-text"><a href="https://www.ahdxpm.com/" target="_blank"  style="color: white;">鼎信数智技术集团股份有限公司</a></span>
                        <span class="foot-text right-text"><a href="https://ggzy.hefei.gov.cn/" target="_blank"  style="color: white;">安徽公共资源交易集团项目管理有限公司</a></span>
                        <span class="foot-text right-text"><a href="https://zbcg.mas.gov.cn/masggzynew/index.html" target="_blank"  style="color: white;">马鞍山市政府集中采购中心</a></span>
                    </div>
                    <div class="split-right">
                        <span class="foot-text right-text"><a href="https://www.baohuabidding.com/shbhgjzb/" target="_blank"  style="color: white;">上海宝华国际招标有限公司安徽分公司</a></span>
                        <span class="foot-text right-text"><a href="https://www.masxmzx.com/" target="_blank"  style="color: white;">马鞍山市兴马项目咨询有限公司</a></span>
                        <span class="foot-text right-text"><a href="http://www.ahhtzx.com.cn/" target="_blank"  style="color: white;">恒泰工程咨询集团有限公司</a></span>
                    </div>
                </div>

            </div>
        </div>
        <div class="bottom">
            <span class="bottom-text">版权所有</span>
            <div class="b-circle">
                <span style="margin-top:-1px;margin-left:-2px">c</span>
            </div>
            <!-- <span>安徽工业大学 皖ICP备XXXXXXX号 皖公安网备XXX000000009</span> -->
            <span>安徽工业大学</span>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    methods:{
        jumpLink(link){
            // window
        }
    }
};
</script>

<style lang="less" scoped>
.footer {
    display: flex;
    // padding-top: 32px;
    // padding-bottom: 24px;
    padding: 32px 15% 24px;
    justify-content: space-between;
    .left,
    .right {
        display: flex;
        flex-direction: column;
    }
    .split {
        display: flex;
        div {
            display: flex;
            flex-direction: column;
        }
        .split-right {
            margin-left: 38px;
        }
    }
    .right-div {
        display: flex;
        justify-content: space-between;
    }
    .right-text {
        margin-top: 8px;
    }
    .foot-title {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        margin-top: 46px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    .foot-text {
        opacity: 0.75;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        white-space: nowrap;
    }
    .left-text {
        margin-left: 82px;
        margin-right: 24px;
    }
    .text-div {
        margin-top: 8px;
    }
    .text-phone {
        margin-left: 82px;
        margin-top: 8px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        opacity: 0.75;
        color: #ffffff;
    }
    .phone-right {
        font-family: Barlow-BoldItalic;
        font-weight: BoldItalic;
        color: #ffffff;
    }
}
.barlogo {
    width: 300px;
    height: 72px;
    margin-bottom: 10px;
}
.b-circle {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(176, 189, 222, 1);
    margin: 0 8px;
}
.bottom {
    height: 56px;
    width: 100%;
    display: flex;
    align-items: center;
    border-top: 1px solid #4f74d8;
    display: flex;
    justify-content: center;
    span {
        opacity: 0.75;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
    }
}
.footer-wrap {
    width: 100%;
    height: 255px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .footer {
        flex: 1;
    }
    .footer-bg {
        background: #3958ac none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: -1;
    }
    .footer-kong {
        width: 100%;
        height: 32px;
    }
    .footer-jqrj {
        height: 23px;
        margin-bottom: 10px;
        font-family: SourceHanSerifCN-S0pxiBold;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
    }
    .footer-items {
        width: 910px;
        height: 28px;
        margin: 0 auto;
    }
    .footer-item1 {
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        margin-right: 40px;
    }
    .footer-item2 {
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        margin-right: 40px;
    }
    .footer-item3 {
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        margin-right: 40px;
    }
    .footer-item4 {
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        margin-right: 40px;
    }
    .footer-icon {
        float: left;
        width: 20px;
        height: 20px;
        margin-right: 3px;
        background: url("../../static/webp1/国徽@2x.webp");
        background-size: 20px 20px;
        margin-top: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue